<div class="pt-200" fxLayout="column" fxLayoutAlign="center center">
  <ng-container *ngIf="status === '403'; else notFound">
    <div class="status">
      403
    </div>
    <div class="info">Strona niedostępna</div>
  </ng-container>
</div>

<ng-template #notFound>
  <div class="status">
    404
  </div>
  <div class="info">Nie odnaleziono strony</div>
</ng-template>
